import { useQueryClient } from '@tanstack/react-query';

import { useUserController_Login } from '@/services/hooks';

import type { ApiError } from '../shared/errors';

import type { LoginCredentials } from './types';

export interface Login {
    login: (credentials: LoginCredentials) => void;
    isLoading: boolean;
    /** Why the last attempt failed, for `ApiErrorMessage` to put into words. */
    error: ApiError | null;
}

/** Signs in with a password, then clears every cached query and calls `onLoggedIn`. */
export function useLogin(onLoggedIn: () => void): Login {
    const queryClient = useQueryClient();
    const {
        mutate,
        isPending: isLoading,
        error,
    } = useUserController_Login({
        onSuccess: () => {
            queryClient.invalidateQueries();
            onLoggedIn();
        },
    });

    return {
        login: (credentials) => mutate({ requestBody: credentials }),
        isLoading,
        error,
    };
}
